import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, finalize, Observable } from 'rxjs';

import { ExportQueueItem, PaginatedList } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class ExportQueueService extends BaseService {
  private _hasQueuedItems$ = new BehaviorSubject<boolean>(false);

  get hasQueuedItems$(): Observable<boolean> {
    return this._hasQueuedItems$.asObservable();
  }

  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  setQueuedItems(hasQueuedItems: boolean): void {
    this._hasQueuedItems$.next(hasQueuedItems);
  }

  get(loader: string, pageIndex = 0, pageSize = 20): Observable<PaginatedList<ExportQueueItem>> {
    this.loadersService.show(loader);
    return this.http
      .get<PaginatedList<ExportQueueItem>>(`${this.baseUrl}/export-queue`, {
        params: { pageIndex, pageSize },
      })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getByIds(loader: string, ids: string[]): Observable<ExportQueueItem[]> {
    this.loadersService.show(loader);
    return this.http
      .get<ExportQueueItem[]>(`${this.baseUrl}/export-queue/by-ids`, {
        params: { ids },
      })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  cancelExport(loader: string, id: string): Observable<void> {
    this.loadersService.show(loader);
    return this.http
      .post<void>(`${this.baseUrl}/export-queue/cancel`, { id })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }
}
